// import React, { useState } from "react";
// import {
//   Button,
//   Divider,
//   FormFieldSet,
//   InfoTimeCardAdv,
//   PageHeader,
//   PageTitle,
//   useFormHandler,
// } from "../../../../../../components";

// const OffboardingDocuments = () => {
//   const [activityModal, setActivityModal] = useState(false);
//   const { formData, errors, handleChange, validateAllFields } = useFormHandler(
//     {
//       checklist: "",
//     },
//     {
//       checklist: { type: "select", required: true },
//     }
//   );

//   return (
//     <div>
//       <div className="flex gap-8 mb-6 ">
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Offboarding ID"
//             value="EX2022-20"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Date of Release"
//             value="11/11/2021"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Notice Due"
//             value="10/11/2021"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Exit Type"
//             value="Resignation"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Status"
//             value="Released"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//       </div>
//       <PageHeader
//         Section={
//           <div className="flex">
//             <PageTitle
//               title={"OffBoarding documents"}
//               icon={"user_attributes"}
//               tag="p"
//             />
//           </div>
//         }
//         RightSection={
//           <>
//             <Button title="Add Documents" size="sm" icon={"add"} />
//             <Button title="Save" size="sm" />
//           </>
//         }
//       />
//       <Divider />
//       <div className="mt-6 grid grid-cols-3 max-w-7xl gap-x-8 gap-y-6 mb-0">
//         <FormFieldSet
//           type="select"
//           title={"Select Checklist"}
//           placeholder="Select Checklist"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//       </div>
//       <PageHeader
//         RightSection={
//           <>
//             <Button title="Remove" size="sm" />
//           </>
//         }
//       />
//       <div className="mt-6 grid grid-cols-3 max-w-7xl gap-x-8 gap-y-6 mb-6">
//         <FormFieldSet
//           type="select"
//           title={"Document Type"}
//           placeholder="Select Checklist"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//         <FormFieldSet
//           type="text"
//           title={"Document Name"}
//           placeholder="Select Checklist"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//         <FormFieldSet
//           type="select"
//           title={"Status"}
//           placeholder="Select Status"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//         <FormFieldSet
//           type="file"
//           title={"Upload Template"}
//           placeholder="Browse"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//         <FormFieldSet
//           type="radio"
//           title={"Final Document"}
//           placeholder="Select Checklist"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//         <FormFieldSet
//           type="textArea"
//           title={"Comments"}
//           placeholder="Select Checklist"
//           value={formData.exitType}
//           onChange={(value) => handleChange("exitType", value)}
//           error={errors.exitType}
//         />
//       </div>
//       <p>
//         Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
//         <span
//           className="text-info cursor-pointer"
//           onClick={() => setActivityModal(true)}
//         >
//           View All Activites
//         </span>
//       </p>
//     </div>
//   );
// };

// export default OffboardingDocuments;

import React, { useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  InfoTimeCardAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";

const OffboardingDocuments = () => {
  const [showDocumentForm, setShowDocumentForm] = useState(false);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      checklist: "",
      documentType: "",
      documentName: "",
      status: "",
      template: "",
      finalDoc: "Browse",
      comments: "",
    },
    {
      checklist: { type: "select", required: true },
      //   documentType: { type: "select", required: true },
      //   documentName: { type: "text", required: true },
      //   status: { type: "select", required: true },
      //   template: { type: "file", required: true },
      //   finalDoc: { type: "radio", required: true },
      //   comments: { type: "textArea" },
    }
  );

  const handleAddDocument = () => {
    setShowDocumentForm(true);
  };

  const handleRemoveDocument = () => {
    setShowDocumentForm(false);
  };

  const handleSave = () => {
    if (validateAllFields()) {
      console.log("Form Submitted", formData);
    }
  };

  return (
    <div>
      <div className="flex gap-8 mb-6">
        {[
          { title: "Offboarding ID", value: "EX2022-20" },
          { title: "Date of Release", value: "11/11/2021" },
          { title: "Notice Due", value: "10/11/2021" },
          { title: "Exit Type", value: "Resignation" },
          { title: "Status", value: "Released" },
        ].map((item, idx) => (
          <div className="flex-1" key={idx}>
            <InfoTimeCardAdv
              title={item.title}
              value={item.value}
              align="center"
              color="info"
              size="xs"
              prefix=""
              suffix=""
            />
          </div>
        ))}
      </div>

      <PageHeader
        Section={
          <div className="flex">
            <PageTitle
              title="OFFBOARDING DOCUMENTS"
              icon="user_attributes"
              tag="p"
            />
          </div>
        }
        RightSection={
          <>
            <Button
              title="Add Documents"
              size="sm"
              icon="add"
              onClick={handleAddDocument}
            />

            {showDocumentForm && (
              <Button title="Save" size="sm" onClick={handleSave} />
            )}
          </>
        }
      />

      <Divider className="mt-1" />

      {/* Checklist Select */}
      <div className="mt-6 grid grid-cols-3 max-w-7xl gap-x-8 gap-y-6 mb-3">
        <FormFieldSet
          type="select"
          title="Select Checklist"
          placeholder="Select Checklist"
          value={formData.checklist}
          onChange={(value) => handleChange("checklist", value)}
          error={errors.checklist}
        />
      </div>
      {/* Document Form Section */}
      {showDocumentForm && (
        <>
          <PageHeader
            RightSection={
              <Button title="Remove" size="sm" onClick={handleRemoveDocument} />
            }
          />
          <div className="mt-6 grid grid-cols-3 max-w-7xl gap-x-8 gap-y-6 mb-6">
            <FormFieldSet
              type="select"
              title="Document Type"
              placeholder="Select Document Type"
              value={formData.documentType}
              onChange={(value) => handleChange("documentType", value)}
              error={errors.documentType}
            />
            <FormFieldSet
              type="text"
              title="Document Name"
              placeholder="Enter Document Name"
              value={formData.documentName}
              onChange={(value) => handleChange("documentName", value)}
              error={errors.documentName}
            />
            <FormFieldSet
              type="select"
              title="Status"
              placeholder="Select Status"
              value={formData.status}
              onChange={(value) => handleChange("status", value)}
              error={errors.status}
            />
            <FormFieldSet
              type="file"
              title="Upload Template"
              placeholder="Browse"
              value={formData.template}
              onChange={(value) => handleChange("template", value)}
              error={errors.template}
            />
            <FormFieldSet
              type="radio"
              title="Final Document"
              options={[
                { label: "Browse", value: "Browse" },
                { label: "Post-Tax Deduction", value: "Post-Tax Deduction" },
              ]}
              value={formData.finalDoc}
              onChange={(e) => handleChange("finalDoc", e.target.value)}
              error={errors.finalDoc}
            />
            <FormFieldSet
              type="textArea"
              title="Comments"
              placeholder="Enter comments"
              value={formData.comments}
              onChange={(value) => handleChange("comments", value)}
              error={errors.comments}
            />
          </div>
        </>
      )}

      <p className="body-two">
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span className="text-info cursor-pointer">View All Activities</span>
      </p>
    </div>
  );
};

export default OffboardingDocuments;
